import React from 'react';

class Map extends React.Component {

    // 48°13'05.6"N 11°27'35.5"E
    static defaultProps = {
        center: {
            lat: 48.218208,
            lng: 11.459861
        },
        zoom: 15
    };

    buildCard = () => <div className="row">
        <div className="col-lg-6 col-md-12 col-xs-12">
            <div className="contact-info">
                <div className="upper-border">
                    <p><b>Ingenieurbüro für das Bauwesen</b></p>
                    <img src={require('../../assets/images/tbu_head_bg.jpg')} className="background-img" alt="tbu-hintergrund" />
                    <img src={require('../../assets/images/tbu_logo.png')} className="logo-img" alt="tbu-logo" />

                </div>
                <div className="row">
                    <div className="col-lg-4 col-sm-0 col-xs-0" />
                    <div className="col-lg-8 col-sm-12 col-xs-12">
                        <ul>
                            <li>

                                <div className="row">
                                    <div className="col-lg-4 col-sm-6 col-xs-6 prefix" >
                                        <span>Adresse:</span>
                                    </div>
                                    <div className="col-lg-8 col-sm-6 col-xs-6" >
                                        <p>TBU Ingenieurbüro GmbH</p>
                                        <p>{this.props.contact_data.street}</p>
                                        <p>{this.props.contact_data.place}</p>
                                    </div>
                                </div>

                            </li>
                            <li>
                                <div className="row">
                                    <div className="col-lg-4 col-sm-6 col-xs-6 prefix" >
                                        <span>Tel:</span>
                                    </div>
                                    <div className="col-lg-8 col-sm-6 col-xs-6" >
                                        <p>{this.props.contact_data.phone_number}</p>
                                    </div>
                                </div>

                            </li>
                            <li>
                                <div className="row">
                                    <div className="col-lg-4 col-sm-6 col-xs-6 prefix" >
                                        <span>Fax:</span>
                                    </div>
                                    <div className="col-lg-8 col-sm-6 col-xs-6" >
                                        <p>{this.props.contact_data.fax}</p>
                                    </div>
                                </div>

                            </li>
                            <li>
                                <div className="row">
                                    <div className="col-lg-4 col-sm-6 col-xs-6 prefix" >
                                        <span>E-Mail:</span>
                                    </div>
                                    <div className="col-lg-8 col-sm-6 col-xs-6" >
                                        <p>{this.props.contact_data.email}</p>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="bottom-border">
                </div>
            </div>
        </div>
    </div>;

    buildMobileContactInformation = () =>
        <div className="mobile-contact-information">
            <h4><b>TBU Ingenieurbüro GmbH</b></h4>
            <b> <i class="fa fa-map-marker"/> {this.props.contact_data.street + " " + this.props.contact_data.place}</b>
            <br/>
            <b> <i class="fa fa-envelope"/> {this.props.contact_data.email}</b>
            <br/>
            <b> <i class="fa fa-phone" /> {this.props.contact_data.phone_number}</b>
            <br/>
            <b> <i class="fa fa-fax"/> {this.props.contact_data.fax}</b>
        </div>;

    render() {
        return (
            <section id="contact" className="contact-area ptb-80 bg-f6f6f6">
                <div className="section-title">
                        <h4>So erreichen Sie uns</h4>
                        <h2><span>Kontaktinformationen</span></h2>
                        {
                            this.props.useMobileView && this.buildMobileContactInformation()
                        }
                    </div>
                <div id="map">
                <div style={{
                    height: '100%',
                    width: '100%',
                    position: 'relative',
                    overflow: 'hidden',
                    background: '#e5e9e5'
                }}>
                    <svg
                        viewBox="0 0 1600 700"
                        preserveAspectRatio="xMidYMid slice"
                        role="img"
                        aria-labelledby="tbu-map-title"
                        style={{ height: '100%', width: '100%', display: 'block' }}
                    >
                        <title id="tbu-map-title">
                            Schematische Standortdarstellung des TBU Ingenieurbüros in Karlsfeld
                        </title>

                        <rect width="1600" height="700" fill="#e7ebe7" />
                        <rect x="0" y="0" width="430" height="700" fill="#d7e5d5" />
                        <rect x="1230" y="0" width="370" height="700" fill="#d5e4d2" />
                        <rect x="1040" y="440" width="330" height="260" fill="#dce8d7" />

                        <path
                            d="M0 570 C350 510 650 530 900 585 C1180 645 1390 600 1600 530"
                            fill="none"
                            stroke="#a9cad8"
                            strokeWidth="30"
                        />

                        <g fill="none" strokeLinecap="round" strokeLinejoin="round">
                            <path
                                d="M-80 610 C290 500 550 390 790 270 C1080 125 1330 80 1680 20"
                                stroke="#c4c9c7"
                                strokeWidth="100"
                            />
                            <path
                                d="M-80 610 C290 500 550 390 790 270 C1080 125 1330 80 1680 20"
                                stroke="#ffffff"
                                strokeWidth="72"
                            />

                            <path
                                d="M700 -70 C735 130 770 275 825 410 C870 520 930 620 1010 760"
                                stroke="#c4c9c7"
                                strokeWidth="82"
                            />
                            <path
                                d="M700 -70 C735 130 770 275 825 410 C870 520 930 620 1010 760"
                                stroke="#ffffff"
                                strokeWidth="56"
                            />

                            <path
                                d="M380 25 C540 180 665 310 820 430 C970 545 1160 630 1390 720"
                                stroke="#ccd1cf"
                                strokeWidth="44"
                            />
                            <path
                                d="M380 25 C540 180 665 310 820 430 C970 545 1160 630 1390 720"
                                stroke="#ffffff"
                                strokeWidth="27"
                            />

                            <path
                                d="M350 680 C465 530 560 405 670 280"
                                stroke="#ffffff"
                                strokeWidth="22"
                            />
                            <path
                                d="M985 30 C1020 205 1080 345 1220 480"
                                stroke="#ffffff"
                                strokeWidth="22"
                            />
                        </g>

                        <g fill="#b6bdb8" fontFamily="Arial, sans-serif">
                            <text x="1110" y="235" fontSize="34" fontWeight="600">
                                Karlsfeld
                            </text>
                            <text
                                x="750"
                                y="190"
                                fontSize="22"
                                transform="rotate(74 750 190)"
                            >
                                Parkstraße
                            </text>
                            <text
                                x="350"
                                y="505"
                                fontSize="22"
                                transform="rotate(-25 350 505)"
                            >
                                Münchner Straße
                            </text>
                            <text
                                x="925"
                                y="420"
                                fontSize="20"
                                transform="rotate(35 925 420)"
                            >
                                Bajuwarenstraße
                            </text>
                        </g>
                    </svg>

                    <div style={{
                        position: 'absolute',
                        left: '52%',
                        top: '50%',
                        transform: 'translate(-50%, -100%)',
                        zIndex: 2,
                        textAlign: 'center'
                    }}>
                        <img
                            src={require('../../assets/images/marker-red.png')}
                            alt="Standort TBU Ingenieurbüro"
                            style={{
                                width: '45px',
                                height: 'auto',
                                display: 'block',
                                margin: '0 auto'
                            }}
                        />
                    </div>

                    <a
                        href="https://www.google.com/maps/dir/?api=1&destination=Parkstra%C3%9Fe+31b%2C+85757+Karlsfeld"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Route zum TBU Ingenieurbüro in Google Maps öffnen"
                        style={{
                            position: 'absolute',
                            right: '20px',
                            bottom: '20px',
                            zIndex: 3,
                            display: 'inline-block',
                            padding: '12px 18px',
                            borderRadius: '3px',
                            background: '#2386c8',
                            color: '#ffffff',
                            fontSize: '15px',
                            fontWeight: '600',
                            textDecoration: 'none',
                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.22)'
                        }}
                    >
                        <i
                            className="fa fa-map-marker"
                            aria-hidden="true"
                            style={{ marginRight: '8px' }}
                        />
                        Route in Google Maps öffnen
                    </a>
                </div>
            </div>
            {
                    !this.props.useMobileView && this.buildCard()
                }

            </section>
        );
    }
}

export default Map;
